'use client';

import React, { ReactNode, useCallback, useMemo } from 'react';
import { useAppSelector } from '@lib/hooks/redux-hooks';
import { getIsMobile } from '@lib/redux/selectors/browser';

import Carousel from '@nerdwallet/react-carousel';
import { Box } from '@nerdwallet/currency/components/Box';
import { useAnalytics } from '@lib/segment';

import styles from './rewards-tracker-list.module.scss';

interface Props {
  children: ReactNode;
}

const RewardsTrackerList: React.FC<Props> = ({ children }) => {
  const { segmentTrack } = useAnalytics();
  const isMobile = useAppSelector(getIsMobile);

  const emitCarouselSwipeEvent = useCallback(() => {
    segmentTrack('NW Plus Reward Tracker Module Swiped');
  }, [segmentTrack]);

  const commonProps = useMemo(
    () => ({
      dots: true,
      className: styles.carousel,
      beforeChange: emitCarouselSwipeEvent,
    }),
    [emitCarouselSwipeEvent],
  );

  return (
    <React.Fragment>
      <Box className={styles.carouselWrapper}>
        <Carousel {...commonProps} slidesToShow={isMobile ? 1 : 2}>
          {children}
        </Carousel>
      </Box>
    </React.Fragment>
  );
};

export default RewardsTrackerList;
